import { render, staticRenderFns } from "./ruleEnigeDetail.vue?vue&type=template&id=40b39cfb&"
import script from "./ruleEnigeDetail.vue?vue&type=script&lang=js&"
export * from "./ruleEnigeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ruleEnigeDetail.vue?vue&type=style&index=0&id=40b39cfb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports